module.exports = __webpack_public_path__ + "static/media/play-button.24bb57f6.svg";